import { render, staticRenderFns } from "./DetailImageInfo.vue?vue&type=template&id=324ea73b&scoped=true&"
import script from "./DetailImageInfo.vue?vue&type=script&lang=js&"
export * from "./DetailImageInfo.vue?vue&type=script&lang=js&"
import style0 from "./DetailImageInfo.vue?vue&type=style&index=0&id=324ea73b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324ea73b",
  null
  
)

export default component.exports